<script setup lang="ts">
const props = defineProps<{
  title: string;
  content: string;
}>();
</script>

<template>
  <div class="table-of-content">
    <h3
      data-bs-toggle="collapse"
      href="#tableOfContent"
      role="button"
      aria-expanded="false"
      aria-controls="tableOfContent"
    >
      {{ props.title }}
    </h3>
    <div class="collapse show" id="tableOfContent" v-html="props.content"></div>
  </div>
</template>
